import axios from '../config/axios';

const GET_QST = 'api/Question/trouverQuestion';
const GET_TPE_REP_LIST = 'api/TypeReponse/listTypeReponses';

export const getQst = (id) => {
    return axios.get(GET_QST, {
        params: {
            id: id,
        }
    });
};


export const getTpeRepList = () => {
    return axios.get(GET_TPE_REP_LIST);
};